module.exports = __webpack_public_path__ + "img/jnrh-banner.6080036e.jpg";